import type { Channel } from '../../../api';

/** The channel E5 sets up and how many selected channels remain after it (S7 R2, R3). */
export interface FirstChannelPick {
  readonly channel: Channel;
  /** Other selected channels, accessible and not set up yet: Home will ask for them (R2). */
  readonly othersToSetUp: number;
}

/** A selected channel the trader can reach and that has no settings version yet. */
function needsSetup(channel: Channel): boolean {
  return channel.accessible && channel.subscription?.status === 'NOT_CONFIGURED';
}

/**
 * The channel E5 sets up first (S7 R3, AC2; Q84 provisional): the affiliate's recommended one
 * when the trader selected it, else the first selected one in the API's order (S5 R12 already
 * lists recommended rows first, so both rules agree on a well-formed answer). Only accessible
 * rows whose subscription is `NOT_CONFIGURED` qualify: a channel already set up (`ACTIVE`,
 * `PAUSED`, suspended), inactive or unselected is never shown. `null` when none qualifies, so E5
 * is skipped (R12). Pure: no request, no ordering of its own beyond the recommended-first rule.
 */
export function pickFirstChannel(channels: readonly Channel[]): FirstChannelPick | null {
  const candidates = channels.filter(needsSetup);
  const channel = candidates.find((row) => row.recommendedByAffiliate) ?? candidates[0];
  if (channel === undefined) return null;
  return { channel, othersToSetUp: candidates.length - 1 };
}
